class SrApplyLink {
  constructor(elem) {
    this.elem = elem[0];
    this.bindEvents();
  }

  bindEvents() {
    this.elem.addEventListener("click", () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "apply_here_click",
        link_text: this.elem.getAttribute("data-link_text"),
        link_url: this.elem.getAttribute("href"),
      });
    });
  }
}

export default SrApplyLink;
